import { render, staticRenderFns } from "./DepartmentTabs.vue?vue&type=template&id=5f4dd31a&scoped=true"
var script = {}
import style0 from "./DepartmentTabs.vue?vue&type=style&index=0&id=5f4dd31a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4dd31a",
  null
  
)

export default component.exports